import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-customers',
    imports: [
        RouterOutlet
    ],
    templateUrl: './customers.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './customers.component.scss'
})
export class CustomersComponent {

}
